<template>
	<div v-for="(room, index) in items" :key="room.pageID" class="row contentblock" :class="{ even: index % 2 == 0 }">
		<div class="columns column6 contentblock-content">
			<h2>{{ room.header }}</h2>
			<div v-parse-links v-html="room.overviewContent" />
			<slot
				name="extra-content"
				:facilities="room.facilities"
				:filename="localePath(`/${room.filename}`)"
				:bookingid="room.bookingID"
			/>
		</div>
		<div class="contentblock-image">
			<picture>
				<source v-if="room.imageOverviewWebp" :srcset="room.imageOverviewWebp" type="image/webp" />
				<source :srcset="room.imageOverview" />
				<img loading="lazy" :src="room.imageOverview" :alt="room.imageOverviewAlt" />
			</picture>
		</div>
	</div>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblock {
	margin: 40px auto;
	position: relative;
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 58%;
	z-index: 1;
}

.contentblock-content {
	background: #fff;
	backdrop-filter: blur(34px);
	padding: 60px 90px;
	margin: 60px auto 0;
	position: relative;
	z-index: 2;

	h2 {
		padding-bottom: 20px;
		border-bottom: 1px solid black;
	}
}

.even {
	.contentblock-image {
		left: 0;
		right: auto;
	}

	.contentblock-content {
		float: right;
	}
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 1180px) {
	.column6 {
		width: 50%;
	}
}

@media (max-width: 920px) {
	.column6 {
		width: 100%;
	}

	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
	}
}
</style>
